var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.767442 0.767442H6.90698M13.0465 0.767442H19.186M3.83721 0.767442V5.88372M16.1163 0.767442V5.88372M4.60465 11H3.83721C3.02306 11 2.24225 10.6406 1.66656 10.001C1.09086 9.36132 0.767442 8.49376 0.767442 7.58915V5.88372H19.186V7.58915C19.186 8.49376 18.8626 9.36132 18.2869 10.001C17.7112 10.6406 16.9304 11 16.1163 11H15.3488M4.60465 11C4.60465 12.3569 5.08978 13.6583 5.95332 14.6178C6.81686 15.5772 7.98807 16.1163 9.2093 16.1163H10.7442C11.9654 16.1163 13.1366 15.5772 14.0002 14.6178C14.8637 13.6583 15.3488 12.3569 15.3488 11M4.60465 11H15.3488M5.37209 13.814C4.64704 14.5317 4.067 15.4119 3.67017 16.3967C3.27334 17.3814 3.06872 18.4483 3.06977 19.5271V21.2326H4.60465M14.5814 13.814C15.3065 14.5317 15.8865 15.4119 16.2833 16.3967C16.6802 17.3814 16.8848 18.4483 16.8837 19.5271V21.2326H15.3488",
    stroke: "#E4E4E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUavIcon);
export default __webpack_public_path__ + "static/media/uav-icon.6ca243b65155929af0d9c1b71872bdbd.svg";
export { ForwardRef as ReactComponent };